import styled from "styled-components";

export const SContainer = styled.div`
	display: flex;
	justify-content: center;
	padding-block: 47px 40px;
`;
